module.exports = __webpack_public_path__ + "static/media/join-4.b28a2889.png";